const ServicesHero = () => {
  return (
    <section className="relative pt-32 pb-20 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: 'linear-gradient(to right, cyan 1px, transparent 1px), linear-gradient(to bottom, cyan 1px, transparent 1px)',
            backgroundSize: '100px 100px'
          }}></div>
        </div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto">
          <div className="inline-block px-4 py-2 bg-cyan-500/20 text-cyan-300 text-sm font-semibold rounded-full mb-6">
            Our Services
          </div>
          <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Comprehensive IT Solutions for Your Business
          </h1>
          <p className="text-xl text-gray-300 leading-relaxed">
            From strategic consulting to 24/7 support, we provide end-to-end technology services that drive innovation and growth.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ServicesHero;